'use strict';

var chunkBFWPR76Y_js = require('./chunk-BFWPR76Y.js');
var chunkG7XVAAZO_js = require('./chunk-G7XVAAZO.js');
var o = require('react');
var I = require('styled-components');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var o__default = /*#__PURE__*/_interopDefault(o);
var I__default = /*#__PURE__*/_interopDefault(I);

var S=I__default.default.div`
  display: flex;
`,D=({dropdownOptions:u})=>{let{header:l,options:e=[],links:d,resultLinks:p,buttons:b=[]}=u||{},{title:m="",suffixButton:c={}}=l||{},[n,f]=o.useState(0),v=o.useCallback(t=>{f(t);},[n]);return o__default.default.createElement(S,null,o__default.default.createElement(chunkBFWPR76Y_js.a,{title:m,suffixButton:c,onHover:v,links:d,options:e,activeIndex:n}),(e==null?void 0:e.length)>0&&(e==null?void 0:e.map((t,r)=>{var s;let k=(s=e[r])==null?void 0:s.title;return o__default.default.createElement(chunkG7XVAAZO_js.a,{title:t.title,selectedOption:p[k],key:t.title,currentIndexValue:r,activeIndexValue:n,buttons:b})})))};

exports.a = D;
